import { render, staticRenderFns } from "./projectSettings.vue?vue&type=template&id=3040e69a&"
import script from "./projectSettings.vue?vue&type=script&lang=js&"
export * from "./projectSettings.vue?vue&type=script&lang=js&"
import style0 from "./projectSettings.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports